<template>
    <div
        v-if="isOpen"
        ref="dialogRef"
        class="relative z-98"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
    >
        <!-- Backdrop -->
        <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="isOpen"
                class="fixed inset-0 bg-taupe-900/50 transition-opacity"
            ></div>
        </transition>

        <!-- Modal container -->
        <div class="fixed inset-0 z-10 overflow-y-auto">
            <div
                class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
            >
                <!-- Modal content -->
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-if="isOpen"
                        class="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-md sm:p-6 p-4"
                    >
                        <div class="text-left">
                            <h3
                                class="text-lg font-medium leading-6 text-taupe-900"
                                id="modal-title"
                            >
                                {{ title }}
                            </h3>
                            <div class="mt-3 text-sm text-taupe-600">
                                <slot name="body">
                                    <slot></slot>
                                </slot>
                            </div>
                        </div>
                        <div
                            v-if="$slots.buttons"
                            class="mt-6 flex gap-3 justify-end"
                        >
                            <slot name="buttons"></slot>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { useFocusTrap } from '@/composables/useFocusTrap'

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    isOpen: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['close'])

const dialogRef = ref(null)
useFocusTrap(dialogRef, () => props.isOpen)

function onKeydown(event) {
    if (event.key === 'Escape' && props.isOpen) {
        emit('close')
    }
}

onMounted(() => {
    document.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
    document.removeEventListener('keydown', onKeydown)
})
</script>
